import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import createCachedSelector from 're-reselect';
import DataConfig from '..';
import { addMissingParts as addCtxMenuMissingParts } from '../Grid/contextMenu/createContextMenuOption';

var gridSettingsSelector = function gridSettingsSelector(state, props) {
  return props;
};

var gridViewSelector = function gridViewSelector(state, _ref) {
  var id = _ref.id;
  return state.grid.views[id];
};

var gridSelectionSelector = function gridSelectionSelector(state, _ref2) {
  var id = _ref2.id;
  return state.grid.selection[id];
};

export var gridDataSelector = function gridDataSelector(state, _ref3) {
  var id = _ref3.id;
  var view = state.grid.views[id] || {
    id: id
  };
  var dataKey = view.dataKey || view.id;
  return state.grid.data[dataKey] || {};
};

var getColumns = function getColumns(_ref4) {
  var builtInType = _ref4.builtInType,
      props = _ref4.props;
  if (!builtInType && props.columns) return props.columns;
  var columns = [];
  if (builtInType && builtInType.columns) columns = builtInType.columns;

  if (props.columns) {
    var genericOverride = props.columns.find(function (c) {
      return c.id === true;
    }) || {};
    var genericBuiltIn = columns.find(function (c) {
      return c.id === true;
    }) || {};

    var generic = _objectSpread({}, genericBuiltIn, genericOverride);

    columns = props.columns.filter(function (c) {
      return c.id !== true;
    }).map(function (column) {
      var builtInId = null;
      if (typeof column === 'string') builtInId = column;else if (column.id) builtInId = column.id;
      var builtInColumn = columns.find(function (c) {
        return c.id === builtInId;
      });

      if (builtInColumn) {
        if (typeof column === 'string') return builtInColumn;
        return _objectSpread({}, builtInColumn, column);
      } else {
        if (generic) {
          var id = builtInId;

          var newColumn = _objectSpread({
            children: id
          }, generic, {
            id: id
          });

          if (typeof column !== 'string') {
            var _id = column.id,
                rest = _objectWithoutProperties(column, ["id"]);

            newColumn = _objectSpread({}, newColumn, rest);
          }

          if (typeof newColumn.type === 'function') {
            newColumn.type = newColumn.type(newColumn);
          }

          if (typeof newColumn.children === 'function') {
            newColumn.children = newColumn.children(newColumn);
          }

          return newColumn;
        }
      }

      return column;
    }).filter(function (c) {
      return c !== null;
    });
  } //mark columns as sortable/filterable


  columns = columns.map(function (col) {
    var filterable = false;
    if (col.serverFilter || col.inMemoryFilter) filterable = true;
    var sortable = false;
    if (col.serverSort || col.inMemorySort) sortable = true;
    return _objectSpread({}, col, {
      sortable: sortable,
      filterable: filterable
    });
  });
  return columns;
};
/**@return {import('data/types').DataGridViewState} */


var getGridState = function getGridState(props, view, selection, data) {
  var viewId = view && view.id && props.id;

  if (!viewId) {
    var defaultView = {
      page: 0,
      itemsPerPage: 10,
      isLoading: true,
      dataProps: {}
    };
    if (props.mode) defaultView.mode = props.mode;
    return {
      count: 0,
      view: defaultView,
      data: props.data || [],
      columns: getColumns({
        props: props
      }),
      thumbnail: props.thumbnail || {},
      dataProps: props.gridProps
    };
  }

  var builtInType = null;
  if (viewId && DataConfig[viewId]) builtInType = DataConfig[viewId];else if (props.dataType && DataConfig[props.dataType]) builtInType = DataConfig[props.dataType];else if (view.dataType && DataConfig[view.dataType]) builtInType = DataConfig[view.dataType];
  var dataType = props.dataType || view.dataType;
  var columns = getColumns({
    builtInType: builtInType,
    props: props
  });
  var thumbnail = {};
  if (builtInType && builtInType.thumbnail) thumbnail = builtInType.thumbnail;
  if (props.thumbnail) thumbnail = props.thumbnail;
  var contextMenu = false;
  if (builtInType && builtInType.contextMenu) contextMenu = builtInType.contextMenu;

  if (typeof props.contextMenu !== 'undefined') {
    if (props.contextMenu && props.contextMenu.length) {
      var gridMenu = [];
      props.contextMenu.map(function (gridEntry) {
        if (typeof gridEntry === 'string') return gridMenu.push(gridEntry);
        var entry = {};

        if (contextMenu) {
          if (gridEntry.id) entry = contextMenu.find(function (e) {
            return e.id === gridEntry.id;
          }) || {};else if (gridEntry.type) entry = contextMenu.find(function (e) {
            return e.type === gridEntry.type;
          }) || {};
        }

        gridMenu.push(_objectSpread({}, entry, gridEntry));
      });
      contextMenu = gridMenu.map(function (m) {
        return addCtxMenuMissingParts(m);
      });
    } else {
      contextMenu = props.contextMenu;
    }
  }

  if (contextMenu === true) contextMenu = builtInType.contextMenu;
  var hoverable = false;
  if (builtInType && typeof builtInType.hoverable !== 'undefined') hoverable = builtInType.hoverable;
  if (typeof props.hoverable !== 'undefined') hoverable = props.hoverable;
  var idKeyProp = 'Id';
  if (builtInType && typeof builtInType.data.idKeyProp !== 'undefined') idKeyProp = builtInType.data.idKeyProp;
  var allData = view.all || {};
  var currentWindow = [];
  var crtStartIdx = view.page * view.itemsPerPage;

  for (var itemIdx = 0; itemIdx < view.itemsPerPage; itemIdx++) {
    var absoluteIdx = crtStartIdx + itemIdx;
    if (absoluteIdx >= 0 && absoluteIdx < view.count) currentWindow.push(allData[absoluteIdx]);
  }

  return {
    count: view.count || 0,
    view: view,
    data: currentWindow.map(function (id) {
      if (!id) return; //loading placeholder

      return _objectSpread({}, data[id], {
        _selected: selection && selection.indexOf(id) > -1 ? true : false
      });
    }),
    columns: columns,
    thumbnail: thumbnail,
    contextMenu: contextMenu,
    hoverable: hoverable,
    idKeyProp: idKeyProp,
    dataType: dataType,
    dataProps: props.dataProps
  };
};
/**
 * @type {(state: object, props: import('data/Grid/types').DataGridModeSwitcherProps) => import('data/types').DataGridViewState}
 */


var selector = createCachedSelector(gridSettingsSelector, gridViewSelector, gridSelectionSelector, gridDataSelector, getGridState)(function (state, _ref5) {
  var id = _ref5.id;
  return id;
});
export default selector;